import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-cream px-4 py-9 sm:px-6 sm:py-12" data-id="element-102" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-4xl flex-col items-start gap-5 rounded-2xl border-2 border-gold bg-white p-5 sm:flex-row sm:p-7" data-id="element-103" data-mp="1o5q2iivokc11">
        <ShieldCheckIcon aria-hidden="true" className="h-12 w-12 shrink-0 text-gold sm:h-16 sm:w-16" strokeWidth={1.4} data-id="element-104" data-mp="1x3tothehpctw" />
        <div data-id="element-105" data-mp="19co9r4gdiokn">
          <p className="font-display text-[11px] font-bold uppercase tracking-[0.18em] text-sage-dark" data-id="element-106" data-mp="14fo1qnzyrbqw">
            Zéro risque
          </p>
          <h2 className="mt-1 text-lg font-extrabold leading-tight sm:text-2xl" data-id="element-107" data-mp="1j5lu7g4xenlw">
            Garantie satisfait ou remboursé de 7 jours
          </h2>
          <p className="mt-2 text-[13px] leading-snug text-graphite/85 sm:text-sm" data-id="element-108" data-mp="1ec0rxbwav7gw">
            Ouvrez le système complet. Explorez les six modules. Découvrez les activités, séances,
            progressions, outils, supports et bonus.
          </p>
          <p className="mt-1.5 text-[13px] leading-snug text-graphite/85 sm:text-sm" data-id="element-109" data-mp="oygoin5pjsei">
            Essayez ORTHOPHONIE PRO™ pendant sept jours complets. Si le système ne vous convient
            pas, contactez-nous pendant la période de garantie et demandez votre remboursement
            conformément aux conditions applicables.
          </p>
          <p className="mt-3 inline-block rounded-full bg-petrol px-3 py-1 font-display text-[10px] font-extrabold uppercase tracking-widest text-white" data-id="element-110" data-mp="12sr4og3n2e8y">
            Votre achat est protégé
          </p>
        </div>
      </div>
    </section>;
}